import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const RetrieveQuote = {
  Content: lazy(
    () => import('components/retrieve-quote/components/RetrieveQuoteContent')
  ),
  Header: lazy(
    () => import('components/retrieve-quote/components/RetrieveQuoteHeader')
  )
};

export default RetrieveQuote;
